import React from 'react'
import { withRouter } from 'react-router-dom'
import { View, Text, TouchableHighlight, StyleSheet } from 'react-native'
import Icon from 'react-native-vector-icons/dist/FontAwesome'
import { headerHeight, themeColor, white } from './_variables.scss'

const GoBack = withRouter(({ history }) => (
  <TouchableHighlight
    style={styles.backButton}
    onPress={() => history.goBack()}
  >
    <View style={styles.headerButtonContainer}>
      <Icon name="chevron-left" size={24} color="#fff" />
    </View>
  </TouchableHighlight>
))

const AppHeader = ({ title = 'チャットボット', goBack = true }) => {
  return (
    <View style={styles.header}>
      {goBack && <GoBack />}
      <Text
        accessibilityRole="heading"
        aria-level={1}
        style={styles.headerText}
      >
        {title}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    position: 'fixed',
    width: '100vw',
    height: parseInt(headerHeight, 10),
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: themeColor,
    zIndex: 9999,
  },
  headerButtonContainer: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  headerText: {
    width: '100%',
    padding: 4,
    fontSize: '140%',
    color: white,
    textAlign: 'center',
  },
  backButton: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    paddingHorizontal: 8,
  },
})

export default AppHeader
